#!/usr/bin/env node

import fs from 'node:fs'
import os from 'node:os'
import path from 'node:path'

import { ContinuousIntegration as CI } from './continuous-integration'
import { pkg, root } from './find-root'

export function version(): string {
  let $version = pkg.version as string

  if (CI.service && !CI.tag) {
    $version = `${$version}.${CI.build_number}`
  }
  else if (!CI.service) {
    $version = `${$version}.${os.userInfo().username}.${os.hostname()}`
  }

  const version_module = path.join(root, 'gen', 'version.cjs')
  if (!fs.existsSync(path.dirname(version_module))) fs.mkdirSync(path.dirname(version_module))
  fs.writeFileSync(version_module, `module.exports = { version: ${JSON.stringify($version)} }`)
  console.log('written version', $version, 'to', version_module)
  return $version
}

version()
